/* Mock data for the Goose prototype — grounded in the real KB & brief */
window.MAV = (function () {

  const clients = [
    { slug: 'synchrony', name: 'Synchrony', color: '#3B3C43', accent: '#FBC600', initials: 'SY', colors: ['#FBC600','#3B3C43','#34657F'], font: 'Arial', width: 600, refs: 15, flags: ['Image CTAs only','SFMC','No dark mode'], esp: 'SFMC', esps: ['SFMC','Zeta','Epsilon Harmony'],
      presets: [
        { id: 'zeta-unsub',     name: 'Zeta-Unsub variant',    desc: 'Zeta-compliant unsubscribe + preference-center footer block' },
        { id: 'amp-heavy',      name: 'AMP-heavy variant',      desc: 'AMP for Email interactive blocks with HTML fallback' },
        { id: 'legacy-harmony', name: 'Legacy Harmony variant', desc: 'Epsilon Harmony legacy table layout & merge tags' },
      ] },
    { slug: 'cricket-wireless', name: 'Cricket Wireless', color: '#6FBF44', accent: '#6FBF44', initials: 'CR', colors: ['#6FBF44','#1B1B1B','#0A8A3E'], font: 'Arial', width: 600, refs: 8, flags: ['SFMC'], esp: 'SFMC', esps: ['SFMC','Zeta'] },
    { slug: 'vancity', name: 'Vancity', color: '#D2232A', accent: '#D2232A', initials: 'VC', colors: ['#D2232A','#1B1B1B','#F4A81D'], font: 'Plus Jakarta Sans', width: 600, refs: 6, flags: ['Web fonts'], esp: 'Braze', esps: ['Braze','Marketo'] },
    { slug: 'shippo', name: 'Shippo', color: '#6334E3', accent: '#6334E3', initials: 'SH', colors: ['#6334E3','#1B1B1B','#19C37D'], font: 'Rethink Sans', width: 650, refs: 5, flags: ['650px width'], esp: 'Iterable', esps: ['Iterable','Klaviyo'] },
    { slug: 'snowflake', name: 'Snowflake', color: '#29B5E8', accent: '#29B5E8', initials: 'SN', colors: ['#29B5E8','#1B1B1B','#11567F'], font: 'Lato / Montserrat', width: 600, refs: 7, flags: ['Web fonts','Dark mode'], esp: 'Marketo', esps: ['Marketo','Eloqua'],
      presets: [
        { id: 'dark-hero',  name: 'Dark-mode hero variant', desc: 'Dark-first hero with 2× emit + light-mode fallback' },
        { id: 'summit',     name: 'Summit event variant',   desc: 'Event-reg layout with agenda + speaker grid blocks' },
      ] },
    { slug: 'the-general', name: 'The General', color: '#0B5C9E', accent: '#F47B20', initials: 'TG', colors: ['#0B5C9E','#F47B20','#1B1B1B'], font: 'Open Sans', width: 750, refs: 4, flags: ['750px width'], esp: 'SFMC', esps: ['SFMC','Oracle Responsys'] },
    { slug: 'shea-homes', name: 'Shea Homes', color: '#1F3D2B', accent: '#A88A4A', initials: 'SH', colors: ['#1F3D2B','#A88A4A','#1B1B1B'], font: 'Neutraface', width: 600, refs: 9, flags: ['Paid fonts'], esp: 'SFMC', esps: ['SFMC','Acoustic'] },
    { slug: 'fca-canada', name: 'FCA Canada', color: '#B11116', accent: '#B11116', initials: 'FC', colors: ['#B11116','#1B1B1B','#8C8C8C'], font: 'Roboto', width: 600, refs: 11, flags: ['Bilingual'], esp: 'SFMC', esps: ['SFMC','Eloqua'],
      presets: [
        { id: 'bilingual', name: 'Bilingual FR/EN variant', desc: 'Stacked FR + EN with language-anchor jump links' },
      ] },
  ];

  const stageDefs = [
    { id: 'ingest',   no: '01',  name: 'Ingestion', model: 'gemini-3.5-flash',  produces: 'brief.md · inventory' },
    { id: 'semantic', no: '1.6', name: 'Semantic',  model: 'claude-sonnet-4.6', produces: 'frames.json · crops' },
    { id: 'plan',     no: '02',  name: 'Planning',  model: 'deepseek-v4-pro',   produces: 'code-plan.md' },
    { id: 'exec',     no: '03',  name: 'Execution', model: 'gemini-3.5-flash',  produces: 'index.html · images/' },
    { id: 'qa',       no: '04',  name: 'QA',        model: 'perceptron-mk1',    produces: 'qa-report.md' },
    { id: 'approve',  no: '05',  name: 'Approval',  model: 'deepseek-v4-pro',   produces: 'approval.md · .zip' },
  ];

  // status: queued | running | done | failed | review
  function mkStages(states, tokens, times) {
    return stageDefs.map((s, i) => ({ ...s, status: states[i], tokens: tokens[i], elapsed: times[i] }));
  }

  const jobs = [
    {
      id: 'bld_8KQ2', name: '15012935_SYF_FLR_0176_Rate_Update', client: 'synchrony', source: 'pdf', engine: 'router',
      status: 'needs_review', verdict: 'CONDITIONAL', owner: 'You', started: '6 min ago', tokensK: 412, cost: 0.21,
      confidence: 0.71, activeStage: 5,
      stages: mkStages(['done','done','done','done','done','review'],['38K','141K','62K','97K','58K','16K'],['12s','41s','22s','55s','31s','9s']),
    },
    {
      id: 'bld_7Y4M', name: 'Cricket_Q3_Activation_Promo', client: 'cricket-wireless', source: 'pdf', engine: 'codex', limitHit: true,
      status: 'running', verdict: null, owner: 'You', started: '2 min ago', tokensK: 173, cost: 0.09,
      confidence: 0.94, activeStage: 3,
      stages: mkStages(['done','done','done','running','queued','queued'],['36K','138K','58K','—','—','—'],['11s','38s','20s','…','—','—']),
    },
    {
      id: 'bld_5T1A', name: 'Snowflake_Summit_Reg_Reminder', client: 'snowflake', source: 'figma', engine: 'legacy',
      status: 'failed', verdict: 'FAIL', owner: 'A. Rao', started: '22 min ago', tokensK: 211, cost: 0.12,
      confidence: 0.88, activeStage: 3,
      stages: mkStages(['done','done','done','failed','queued','queued'],['41K','152K','77K','—','—','—'],['13s','44s','25s','—','—','—']),
    },
    {
      id: 'bld_3R9P', name: 'Shippo_Carrier_Update_June', client: 'shippo', source: 'pdf', engine: 'codex',
      status: 'complete', verdict: 'PASS', owner: 'You', started: '1 hr ago', tokensK: 389, cost: 0.19,
      confidence: 0.97, activeStage: 6,
      stages: mkStages(['done','done','done','done','done','done'],['34K','129K','61K','92K','55K','18K'],['10s','37s','19s','51s','29s','8s']),
    },
    {
      id: 'bld_2W6E', name: 'TheGeneral_Auto_Renewal_Notice', client: 'the-general', source: 'pdf',
      status: 'complete', verdict: 'PASS', owner: 'M. Lin', started: '3 hr ago', tokensK: 356, cost: 0.18,
      confidence: 0.95, activeStage: 6,
      stages: mkStages(['done','done','done','done','done','done'],['33K','126K','59K','88K','52K','17K'],['10s','36s','18s','49s','27s','8s']),
    },
    {
      id: 'bld_1H8C', name: 'Vancity_Member_Dividend_2026', client: 'vancity', source: 'figma',
      status: 'needs_review', verdict: 'CONDITIONAL', owner: 'A. Rao', started: '4 hr ago', tokensK: 401, cost: 0.20,
      confidence: 0.64, activeStage: 5,
      stages: mkStages(['done','done','done','done','done','review'],['37K','139K','63K','95K','56K','15K'],['11s','40s','21s','53s','30s','9s']),
    },
  ];

  const reviewFindings = [
    { section: 'Hero (animated GIF)', tag: 'pass',  note: 'Pixel match 98.2% · alt text present' },
    { section: 'Headline + subhead', tag: 'pass',  note: 'Type, weight & color match spec' },
    { section: 'Rate table',         tag: 'minor', note: 'Single-image table — alt text pipe-delimited OK, verify legibility @125%' },
    { section: 'CTA composite',      tag: 'pass',  note: 'Image CTA wrapped in single <a>, href present' },
    { section: 'Legal disclaimer',   tag: 'minor', note: 'Color #343741 vs body #3B3C43 — confirm intentional (SBS spec)' },
    { section: 'GEN code',           tag: 'pass',  note: 'GEN-26-0176 · right-aligned · 12px/20px' },
  ];

  const presendActions = [
    { id: 'cdn', label: 'Swap local image paths → SFMC CDN URLs', done: false },
    { id: 'track', label: 'Confirm opencounter tracking tag present', done: false },
    { id: 'gen', label: 'Verify GEN code GEN-26-0176', done: false },
    { id: 'cta', label: 'Verify CTA href + utm_medium=email', done: false },
    { id: 'gif', label: 'Upload animated hero GIF to image library', done: false },
  ];

  const liveLog = [
    { t: '00:00', c: 'info', m: 'Stage 03 · Execution — model gemini-3.5-flash (vision)' },
    { t: '00:01', c: '',     m: 'Loading code-plan.md (62K tokens) + 6 element crops' },
    { t: '00:03', c: '',     m: 'Building table skeleton · 600px container · MSO reset' },
    { t: '00:07', c: 'ok',   m: '✓ Header block emitted (logo, preheader spacers ×112)' },
    { t: '00:11', c: 'ok',   m: '✓ Hero region — hero.gif referenced, alt text set' },
    { t: '00:14', c: 'warn', m: '⚠ rate_table.png crop @ 1180px — downscaling to 600' },
    { t: '00:16', c: '',     m: 'Emitting rate table as single image + pipe alt text' },
    { t: '00:19', c: 'cur',  m: '› Generating CTA composite band…' },
  ];

  /* ---- Org hierarchy: Department → Sub-department → Team → (clients · members) ---- */
  // V1 live org. CRM + Internal are real departments, not yet onboarded with teams.
  const org = {
    id: 'mavlers', name: 'Mavlers',
    departments: [
      { id: 'email', name: 'Email Production', subDepts: [
        { id: 'dedicated', name: 'Dedicated' },
        { id: 'retail',    name: 'Retail' },
      ] },
      { id: 'crm',      name: 'CRM',      subDepts: [] },
      { id: 'internal', name: 'Internal', subDepts: [] },
    ],
  };

  // Teams (a.k.a. "assigned-client pods"). Each lives under a dept + sub-dept and
  // is assigned a set of client profiles. `pods` name kept for back-compat.
  const pods = [
    { id: 'lunne',     name: 'Lunne',     dept: 'email', subDept: 'dedicated', leadId: 'ar', lead: 'A. Rao',
      clientSlugs: ['synchrony', 'vancity', 'shea-homes'],          clients: 'Synchrony · Vancity · Shea Homes' },
    { id: 'ehealth',   name: 'eHealth',   dept: 'email', subDept: 'dedicated', leadId: 'ml', lead: 'M. Lin',
      clientSlugs: ['the-general', 'fca-canada', 'cricket-wireless'], clients: 'The General · FCA Canada · Cricket' },
    { id: 'inboxarmy', name: 'InboxArmy', dept: 'email', subDept: 'retail',    leadId: 'ko', lead: 'K. Osei',
      clientSlugs: ['shippo', 'snowflake'],                          clients: 'Shippo · Snowflake' },
  ];

  // status: online | idle | offline · limit/used are monthly $ caps per dev
  const team = [
    { id: 'jd', name: 'Jordan Diaz', initials: 'JD', role: 'Admin · Producer', pod: 'lunne', color: 'var(--grad-warm)', status: 'online',
      builds: 28, tokensK: 920, spend: 340, key: 'a1f2', limit: 500, used: 340, rating: 5,
      afterburnersLeft: 3, afterburnersCap: 5, refreshOn: 'Monday, Jun 1',
      comment: 'Rate-table parse nailed it on the first pass.', lastBuild: 'Synchrony_Rate_Update',
      recent: ['Synchrony_Rate_Update', 'SYF_FLR_0176_Update', 'SYF_Welcome_Series'] },
    { id: 'ar', name: 'A. Rao', initials: 'AR', role: 'Team lead · Senior', pod: 'lunne', color: '#6334E3', status: 'online',
      builds: 22, tokensK: 720, spend: 290, key: '7b3c', limit: 500, used: 290, rating: 4,
      comment: 'Solid — but Vancity dark-mode still wants a manual eye.', lastBuild: 'Vancity_Member_Dividend_2026',
      recent: ['Vancity_Member_Dividend_2026', 'Vancity_Q2_Statement', 'Shea_Move_In_Welcome'] },
    { id: 'ps', name: 'P. Shah', initials: 'PS', role: 'Builder', pod: 'lunne', color: '#0B5C9E', status: 'idle',
      builds: 14, tokensK: 460, spend: 180, key: 'c4d9', limit: 250, used: 180, rating: 5,
      comment: 'Saved me an afternoon on the activation promo.', lastBuild: 'Synchrony_Cashback_Q3',
      recent: ['Synchrony_Cashback_Q3', 'Shea_Spring_Tour'] },
    { id: 'ml', name: 'M. Lin', initials: 'ML', role: 'Team lead · Senior', pod: 'ehealth', color: '#1F8A5B', status: 'online',
      builds: 19, tokensK: 620, spend: 245, key: 'e2a7', limit: 500, used: 245, rating: 4,
      comment: 'Good. Approval flagged a false-positive on alt text.', lastBuild: 'TheGeneral_Auto_Renewal_Notice',
      recent: ['TheGeneral_Auto_Renewal_Notice', 'FCA_Recall_Notice_FR', 'TheGeneral_Welcome'] },
    { id: 'dc', name: 'D. Costa', initials: 'DC', role: 'Builder', pod: 'ehealth', color: '#C8553D', status: 'idle',
      builds: 12, tokensK: 390, spend: 232, key: 'b8f1', limit: 250, used: 232, rating: 3,
      comment: 'Execution downscaled my hero crop too aggressively.', lastBuild: 'Snowflake_Summit_Reg_Reminder',
      recent: ['Snowflake_Summit_Reg_Reminder', 'Cricket_Winback_June'] },
    { id: 'ri', name: 'R. Iyer', initials: 'RI', role: 'QA reviewer', pod: 'ehealth', color: '#8C6A1E', status: 'online',
      builds: 9, tokensK: 300, spend: 120, key: 'd5c0', limit: 250, used: 120, rating: 5,
      comment: 'QA report caught the broken CDN ref before I did.', lastBuild: 'Synchrony_Regression_Sweep',
      recent: ['Synchrony_Regression_Sweep', 'QA_Batch_14'] },
    { id: 'ko', name: 'K. Osei', initials: 'KO', role: 'Team lead · Senior', pod: 'inboxarmy', color: '#2A6FDB', status: 'online',
      builds: 16, tokensK: 520, spend: 210, key: 'f3e8', limit: 500, used: 210, rating: 4,
      comment: 'Figma fetch was slow, but the build came back clean.', lastBuild: 'Shippo_Carrier_Update_June',
      recent: ['Shippo_Carrier_Update_June', 'Shippo_Tracking_Digest', 'Snowflake_Webinar_Reminder'] },
    { id: 'tb', name: 'T. Brooks', initials: 'TB', role: 'Builder', pod: 'inboxarmy', color: '#19808A', status: 'offline',
      builds: 8, tokensK: 270, spend: 95, key: '9a2b', limit: 150, used: 95, rating: 4,
      comment: 'Nice — would love a single-column mobile toggle by default.', lastBuild: 'Shippo_Welcome_Flow',
      recent: ['Shippo_Welcome_Flow'] },
  ];

  // severity: blocker | high | medium | low · status: open | resolved
  // state (Jira workflow): triage | in_progress | in_review | resolved
  // type: Bug | Feature request · created/due are ISO; SLA is derived from severity
  const issues = [
    { id: 'IS-204', dev: 'ar', build: 'Vancity_Member_Dividend_2026', sev: 'high', status: 'open', state: 'in_progress',
      type: 'Bug', when: '2 hr ago', assignee: 'jd', reporter: 'ar',
      created: '2026-05-30T08:10:00', due: '2026-06-02T18:00:00', resolvedOn: null,
      labels: ['dark-mode', 'outlook', 'semantic-stage'], watchers: ['jd', 'ar', 'ps'],
      title: 'Dark-mode disclaimer color inverts wrong in Outlook',
      text: 'Dark-mode disclaimer color inverts wrong in Outlook — shipped CONDITIONAL but the swap reads muddy.',
      thread: [
        { kind: 'event', by: 'ar', action: 'reported the issue from build review', when: '2 hr ago' },
        { kind: 'event', by: 'system', action: 'auto-labeled dark-mode · outlook from the QA report', when: '2 hr ago' },
        { kind: 'event', by: 'jd', action: 'self-assigned and set severity to High', when: '1 hr ago' },
        { kind: 'comment', by: 'jd', when: '1 hr ago', text: 'Confirmed on my side — the disclaimer swaps to #1A1A1A on a #111 background in Outlook dark mode. Semantic stage is reading the SBS spec color literally instead of the dark-mode token. Pulling frames.json to check.' },
        { kind: 'comment', by: 'ar', when: '52 min ago', text: "Thanks. For Vancity the dark-mode disclaimer should map to #C8C8C8 — it's in the client kneeboard under 'Dark mode → legal'. Want me to drop the reference in here?" },
        { kind: 'comment', by: 'jd', when: '40 min ago', text: 'Please do. I think the real fix is a prompt tweak on Semantic so it prefers the dark-mode token when the client flag is set — not an Execution change.' },
        { kind: 'comment', by: 'ps', when: '28 min ago', text: '+1 — saw the same muddy swap on Synchrony last week but it shipped PASS because they are image-CTA only. Might be worth a regression sweep across the dark-mode clients.' },
        { kind: 'event', by: 'jd', action: 'set due date to Jun 2', when: '25 min ago' },
        { kind: 'comment', by: 'jd', when: '12 min ago', text: 'Good call. Adding Snowflake + Vancity to a regression batch once the prompt tweak lands. Targeting end of day Monday.' },
      ] },
    { id: 'IS-201', dev: 'dc', build: 'Snowflake_Summit_Reg_Reminder', sev: 'blocker', status: 'open', state: 'triage',
      type: 'Bug', when: '5 hr ago', assignee: 'jd', reporter: 'dc',
      created: '2026-05-30T05:20:00', due: '2026-05-31T12:00:00', resolvedOn: null,
      labels: ['execution-stage', 'image-crop', 'regression'], watchers: ['jd', 'dc', 'ml'],
      title: 'Execution downscales hero crops past 600px and softens edges',
      text: 'Execution downscales hero crops past 600px and softens the edges. Reproduced on 2 of my last 3 builds.',
      thread: [
        { kind: 'event', by: 'dc', action: 'reported the issue', when: '5 hr ago' },
        { kind: 'event', by: 'system', action: 'flagged BLOCKER — pipeline auto-paused Snowflake builds', when: '5 hr ago' },
        { kind: 'comment', by: 'dc', when: '5 hr ago', text: 'Repro: any hero crop above 600px gets downscaled and the edges soften badly. Hit it on Snowflake_Summit and 2 of my last 3 builds. The source crop is sharp — it is the Execution downscale.' },
        { kind: 'comment', by: 'jd', when: '4 hr ago', text: "Yep, that's the bicubic step in Execution. It downscales to container width but ignores 2x retina. We should emit at 1200px and let the container constrain to 600. Looking now." },
        { kind: 'comment', by: 'ml', when: '3 hr ago', text: 'This is probably why The General batch looked soft yesterday too. Can we hold all image-heavy builds until the fix, or just Snowflake?' },
        { kind: 'comment', by: 'jd', when: '3 hr ago', text: 'Just Snowflake for now — it is the only one auto-paused. Others can proceed; the softening is only visible above 600px source. I will widen the hold if needed.' },
        { kind: 'comment', by: 'dc', when: '2 hr ago', text: 'Attached the side-by-side from Summit_Reg. Left is the source crop, right is what Execution emitted — you can see the haloing on the logo edge.' },
        { kind: 'event', by: 'jd', action: 'assigned the issue to themselves', when: '2 hr ago' },
        { kind: 'comment', by: 'jd', when: '90 min ago', text: 'Confirmed the haloing. Fix is staged: a gemini-3.5-flash prompt change + a 2x emit rule. Running it against Summit_Reg now — if it is clean I will lift the Snowflake hold and close.' },
      ] },
    { id: 'IS-198', dev: 'ml', build: 'TheGeneral_Auto_Renewal_Notice', sev: 'medium', status: 'resolved', state: 'resolved',
      type: 'Bug', when: 'Yesterday', assignee: 'ar', reporter: 'ml',
      created: '2026-05-28T14:05:00', due: '2026-06-04T18:00:00', resolvedOn: '2026-05-29T16:30:00',
      labels: ['approval-stage', 'alt-text', 'false-positive'], watchers: ['ml', 'ar'],
      title: 'Alt-text false positive in Approval on pipe-delimited tables',
      text: 'Alt-text false positive in Approval. Resolved via a perceptron-mk1 prompt tweak — closed by A. Rao.',
      thread: [
        { kind: 'event', by: 'ml', action: 'reported the issue', when: 'Yesterday' },
        { kind: 'comment', by: 'ml', when: 'Yesterday', text: "Approval keeps flagging missing alt text on The General's rate table, but the alt is present and pipe-delimited. It's a false positive — blocking otherwise-clean builds." },
        { kind: 'comment', by: 'ar', when: 'Yesterday', text: "Reproduced. perceptron-mk1 isn't parsing pipe-delimited alt as a single attribute — it reads the pipes as separators and thinks the alt is truncated. Tweaking the Approval prompt to handle delimited alt." },
        { kind: 'event', by: 'ar', action: 'self-assigned', when: 'Yesterday' },
        { kind: 'comment', by: 'ar', when: 'Yesterday', text: 'Prompt tweak deployed. Re-ran The General + 4 other delimited-alt builds — all PASS now, no false positives. Closing.' },
        { kind: 'event', by: 'ar', action: 'marked the issue Resolved', when: 'Yesterday' },
      ] },
    { id: 'IS-195', dev: 'tb', build: 'Shippo_Welcome_Flow', sev: 'low', status: 'resolved', state: 'resolved',
      type: 'Feature request', when: '3 days ago', assignee: 'ko', reporter: 'tb',
      created: '2026-05-27T10:30:00', due: '2026-06-10T18:00:00', resolvedOn: '2026-05-28T11:00:00',
      labels: ['mobile', 'feature-request', 'kneeboard'], watchers: ['tb', 'ko'],
      title: 'Add a single-column mobile default toggle',
      text: 'Requested a single-column mobile default. Shipped as a per-build kneeboard toggle instead.',
      thread: [
        { kind: 'event', by: 'tb', action: 'opened a feature request', when: '3 days ago' },
        { kind: 'comment', by: 'tb', when: '3 days ago', text: 'Would love a single-column mobile layout by default for Shippo — I toggle it manually on every build. Small thing, but it adds up.' },
        { kind: 'comment', by: 'ko', when: '3 days ago', text: "Reasonable. I don't think it should be a global default though — some clients (Synchrony) explicitly want multi-column to hold on mobile. Better as a per-build toggle that remembers your last choice." },
        { kind: 'comment', by: 'tb', when: '2 days ago', text: 'That works for me — a sticky per-build toggle is even better than a global default.' },
        { kind: 'event', by: 'ko', action: 'shipped a per-build kneeboard toggle', when: '2 days ago' },
        { kind: 'event', by: 'ko', action: 'marked the issue Resolved', when: '2 days ago' },
      ] },
  ];

  // SLA target (hours) by severity — used by the ticket timeline
  const slaHours = { blocker: 24, high: 72, medium: 168, low: 336 };
  const now = new Date('2026-05-30T10:30:00');

  /* ---- Feedback signal: what devs report back after each build ---- */
  // wouldShip: ship | minor | no · timeSaved in hours · seeds the Admin desk aggregates
  const _fbSeed = { jd: [3.5, 'ship'], ar: [2, 'minor'], ps: [4, 'ship'], ml: [2.5, 'minor'],
                    dc: [1.5, 'no'], ri: [3, 'ship'], ko: [2, 'minor'], tb: [2.5, 'ship'] };
  team.forEach(m => { const s = _fbSeed[m.id] || [2, 'minor']; m.timeSaved = s[0]; m.wouldShip = s[1]; });

  // workspace pass rate (QA verdict) — the accuracy rating maps against this
  const passRate = 91;

  // per-stage dev signal: helped vs needed-cleanup tallies across recent builds
  const stageScores = [
    { id: 'ingest',   name: 'Ingestion',  helped: 24, hurt: 2 },
    { id: 'semantic', name: 'Semantic',   helped: 21, hurt: 6 },
    { id: 'plan',     name: 'Planning',   helped: 25, hurt: 1 },
    { id: 'exec',     name: 'Execution',  helped: 14, hurt: 11 },
    { id: 'qa',       name: 'QA',         helped: 22, hurt: 4 },
    { id: 'approve',  name: 'Approval',   helped: 20, hurt: 5 },
  ];

  const memberById = (id) => team.find(m => m.id === id);

  let _issueSeq = 205; // next key after the seeded IS-204
  // Canonical issue-creation path. Reporter is captured here (defaults to the
  // signed-in user) and is immutable afterwards. The backend maps this to
  // POST /issues. `flagIssue` (build-review) + the build "Report an issue"
  // button both funnel through here so there's a single creation contract.
  function reportIssue({ reporter = currentUser, type = 'Bug', sev = 'medium', title, text, build, stage, labels = [], source = 'report' } = {}) {
    const id = 'IS-' + (_issueSeq++);
    const dueMs = now.getTime() + (slaHours[sev] || 72) * 36e5;
    const labelSet = labels.slice();
    if (stage) labelSet.push(stage + '-stage');
    if (!labelSet.length) labelSet.push(source === 'build-review' ? 'from-review' : (type === 'Feature request' ? 'feature-request' : 'post-delivery'));
    const verb = source === 'build-review' ? 'flagged this issue from build review'
      : source === 'post-delivery' ? 'reported a post-delivery issue on a shipped build'
      : 'reported this issue';
    const iss = {
      id, dev: reporter, build: build || '—', sev, status: 'open', state: 'triage', type,
      when: 'just now', assignee: null, reporter, created: now.toISOString(), due: new Date(dueMs).toISOString(),
      resolvedOn: null, labels: labelSet, watchers: [reporter],
      title: title || 'Reported issue', text: text || '',
      thread: [
        { kind: 'event', by: reporter, action: verb, when: 'just now' },
        ...(stage ? [{ kind: 'event', by: 'system', action: 'auto-routed to triage · tagged ' + stage + '-stage', when: 'just now' }] : []),
        ...(text ? [{ kind: 'comment', by: reporter, when: 'just now', text }] : []),
      ],
    };
    issues.unshift(iss);
    return iss;
  }

  // Build-review feedback path delegates to reportIssue (reporter = the flagging dev).
  function flagIssue({ sev = 'medium', title, text, build, dev = currentUser, labels = [] }) {
    return reportIssue({ reporter: dev, type: 'Bug', sev, title, text, build, labels, source: 'build-review' });
  }

  // Record a dev's per-build feedback into their Admin desk profile + stage signal
  function recordFeedback(devId, { rating, comment, build, timeSaved, wouldShip, stageVotes }) {
    const m = memberById(devId);
    if (!m) return;
    if (rating != null) m.rating = rating;
    if (comment) m.comment = comment;
    if (build) m.lastBuild = build;
    if (timeSaved != null) m.timeSaved = timeSaved;
    if (wouldShip) m.wouldShip = wouldShip;
    if (stageVotes) Object.entries(stageVotes).forEach(([sid, v]) => {
      const s = stageScores.find(x => x.id === sid); if (!s || !v) return;
      if (v === 'up') s.helped += 1; else if (v === 'down') s.hurt += 1;
    });
  }

  /* ---- Knowledge base: canonical client profiles + edit/approval workflow ---- */
  // Per-client distinctive standards woven into the generated markdown.
  const kbNotes = {
    synchrony: { tone: 'Regulated financial-services tone — precise, compliant, never playful.',
      cta: 'Image-based CTAs only — no live-text buttons. Wrap each CTA image in a single <a> with utm_medium=email.',
      img: 'Rate tables ship as a single flattened image with pipe-delimited alt text; verify legibility at 125% zoom.',
      dark: 'Disclaimer maps to the dark-mode token #C8C8C8 on dark backgrounds — never the literal SBS spec color.',
      qa: 'GEN code required, right-aligned, 12px/20px. Broken image refs are a hard gate.' },
    'cricket-wireless': { tone: 'Friendly, value-forward consumer telecom voice.',
      cta: 'Bulletproof VML button fallback required for Outlook; brand green #6FBF44 on CTAs.',
      img: 'Hero GIFs capped at 1MB; provide a static first-frame fallback.',
      dark: 'Standard dark-mode swap; logo uses the light-on-dark lockup.',
      qa: 'SFMC AMPscript validated; preheader present.' },
    vancity: { tone: 'Member-owned, community-credit-union warmth; bilingual-ready.',
      cta: 'Live-text CTAs allowed with web-font fallback to Arial.',
      img: 'Member dividend figures rendered as live text, not images, for accessibility.',
      dark: 'Dark-mode disclaimer #C8C8C8; confirm contrast on the red brand band.',
      qa: 'Web-font subset attached; fallback verified in Outlook.' },
    shippo: { tone: 'Modern logistics SaaS — crisp, helpful, slightly technical.',
      cta: 'Single-column mobile default is sticky per-build (per IS-195).',
      img: 'Tracking widgets are image-based; alt text mirrors the status string.',
      dark: 'Full dark-mode support; 650px container.',
      qa: 'Rethink Sans web font with Arial fallback.' },
    snowflake: { tone: 'Enterprise data-cloud; confident and precise.',
      cta: 'Image CTAs with VML fallback; hero crops must not exceed 600px source (per IS-201).',
      img: 'Execution emits hero images at 2× (1200px) constrained to a 600px container.',
      dark: 'Web-font dark-mode lockup; verify on Outlook 365.',
      qa: 'Lato/Montserrat subset; summit reg links carry UTM.' },
    'the-general': { tone: 'Approachable auto-insurance; plain-language.',
      cta: 'Image CTAs; 750px container width is intentional — do not normalize to 600.',
      img: 'Mascot art ships as transparent PNG with white-bg fallback.',
      dark: 'Standard dark mode; orange accent #F47B20 holds on dark.',
      qa: 'Open Sans; renewal links validated.' },
  };
  const kbDefaultNote = { tone: 'Follow the master brand standard; mirror the reference templates.',
    cta: 'Image-based CTAs wrapped in a single <a>; include utm_medium=email.',
    img: 'Flatten complex tables to images with descriptive alt text.',
    dark: 'Apply the standard dark-mode token swap; verify disclaimer contrast.',
    qa: 'Validate ESP syntax, preheader, and all links before approval.' };

  function kbMarkdown(slug) {
    const c = clients.find(x => x.slug === slug); if (!c) return '';
    const n = kbNotes[slug] || kbDefaultNote;
    return `# ${c.name} — Client Profile

> Canonical brand & build standard the squadron consults during planning, execution, QA and approval. ${n.tone}

## Identity
- **Slug:** \`${c.slug}\`
- **Source:** \`email-kb/02-clients/${c.slug}.md\`
- **Reference templates:** ${c.refs} on file

## Layout & Type
- **Container width:** ${c.width}px
- **Primary font:** ${c.font} (web-safe fallback: Arial)
- **Palette:** ${c.colors.join(' · ')}

## Build standards
${c.flags.map(f => `- ${f}`).join('\n')}
- ${n.tone}

## CTA rules
- ${n.cta}

## Image handling
- ${n.img}

## Dark mode
- ${n.dark}

## ESP / SFMC
- Ships to ${c.esp || 'Salesforce Marketing Cloud (SFMC)'}; merge syntax and dynamic blocks adapt to the platform.
- Upload image assets to the CDN before send; swap local paths.

## QA expectations
- ${n.qa}
- Accessibility (axe) must pass with zero violations; broken references are a hard gate.
`;
  }

  // canonical approved profiles + metadata, keyed by slug
  const kbProfiles = {};
  clients.forEach((c, i) => {
    kbProfiles[c.slug] = {
      slug: c.slug, name: c.name, sourcePath: `email-kb/02-clients/${c.slug}.md`,
      approvedMarkdown: kbMarkdown(c.slug),
      versionId: 'v' + (3 + (i % 4)) + '.' + (i % 3),
      approvedBy: ['A. Rao', 'M. Lin', 'K. Osei'][i % 3],
      approvedAt: ['Apr 18, 2026', 'Mar 30, 2026', 'May 6, 2026', 'Feb 12, 2026'][i % 4],
    };
  });

  // high-impact sections — flagged (not blocked) when a diff touches them
  const KB_RISK = [
    { key: 'container width', label: 'Container width' }, { key: 'font', label: 'Typography' },
    { key: 'dark mode', label: 'Dark mode' }, { key: 'cta', label: 'CTA rules' },
    { key: 'image', label: 'Image handling' }, { key: 'sfmc', label: 'ESP/SFMC' },
    { key: 'esp', label: 'ESP/SFMC' }, { key: 'qa', label: 'QA expectations' },
  ];
  function kbRiskTags(text) {
    const t = (text || '').toLowerCase(); const seen = {};
    KB_RISK.forEach(r => { if (t.includes(r.key)) seen[r.label] = true; });
    return Object.keys(seen);
  }

  // change requests (seeded so the Admin KB-approvals tab has content)
  let _kbSeq = 42;
  const kbRequests = [
    { id: 'KB-41', slug: 'snowflake', sourcePath: 'email-kb/02-clients/snowflake.md',
      requester: 'dc', baseVersion: kbProfiles.snowflake.versionId,
      proposedMarkdown: kbProfiles.snowflake.approvedMarkdown.replace('exceed 600px source (per IS-201).', 'exceed 600px source. Execution now emits at 2× and constrains to 600px — confirmed fix for the soft-crop blocker.'),
      note: 'Document the 2× hero-emit fix from IS-201 so the standard matches the shipped Execution behavior.',
      status: 'pending_review', submittedAt: '3 hr ago', linkedTicket: 'IS-201', reviewedBy: null, adminNote: '' },
    { id: 'KB-40', slug: 'vancity', sourcePath: 'email-kb/02-clients/vancity.md',
      requester: 'ar', baseVersion: kbProfiles.vancity.versionId,
      proposedMarkdown: kbProfiles.vancity.approvedMarkdown.replace('#C8C8C8; confirm contrast on the red brand band.', '#C8C8C8. NEW: pin the dark-mode disclaimer token explicitly in the kneeboard — Semantic was reading the SBS literal.'),
      note: 'Dark-mode disclaimer kept rendering muddy (IS-204). Make the token mapping explicit in the standard.',
      status: 'pending_review', submittedAt: '1 day ago', linkedTicket: 'IS-204', reviewedBy: null, adminNote: '' },
    { id: 'KB-38', slug: 'shippo', sourcePath: 'email-kb/02-clients/shippo.md',
      requester: 'ko', baseVersion: kbProfiles.shippo.versionId,
      proposedMarkdown: kbProfiles.shippo.approvedMarkdown.replace('Single-column mobile default is sticky per-build (per IS-195).', 'Single-column mobile default is now the workspace default for Shippo (shipped IS-195).'),
      note: 'Promote the single-column mobile toggle to the documented default.',
      status: 'approved', submittedAt: '4 days ago', reviewedBy: 'K. Osei', reviewedAt: '3 days ago', adminNote: 'Matches shipped behavior. Approved.' },
  ];

  function submitKBEdit(slug, proposedMarkdown, note, requester) {
    const p = kbProfiles[slug];
    const req = { id: 'KB-' + (_kbSeq++), slug, sourcePath: p.sourcePath, requester: requester || 'jd',
      baseVersion: p.versionId, proposedMarkdown, note: (note || '').trim(),
      status: 'pending_review', submittedAt: 'just now', reviewedBy: null, adminNote: '' };
    kbRequests.unshift(req);
    return req;
  }
  function decideKB(reqId, decision, adminNote) {
    const req = kbRequests.find(r => r.id === reqId); if (!req) return;
    req.reviewedBy = 'Jordan Diaz'; req.reviewedAt = 'just now'; req.adminNote = (adminNote || '').trim();
    if (decision === 'approve') {
      const p = kbProfiles[req.slug];
      p.approvedMarkdown = req.proposedMarkdown; p.approvedBy = 'Jordan Diaz'; p.approvedAt = 'just now';
      const bump = (p.versionId.match(/(\d+)\.(\d+)/) || [0, 0, 0]); p.versionId = 'v' + bump[1] + '.' + (parseInt(bump[2] || 0) + 1);
      req.status = 'approved';
    } else if (decision === 'reject') { req.status = 'rejected'; }
    else { req.status = 'changes_requested'; }
    return req;
  }

  const currentUser = 'jd';   // the signed-in session
  // per-client build volume — "shipped" = completed/delivered builds. trend = last 7 days (Mon→Sun).
  const clientStats = {
    'synchrony':        { month: 34, total: 412, trend: [1, 2, 1, 0, 2, 1, 2] },
    'cricket-wireless': { month: 18, total: 233, trend: [0, 1, 1, 0, 1, 0, 1] },
    'vancity':          { month: 12, total: 96,  trend: [0, 1, 0, 1, 0, 1, 0] },
    'shippo':           { month: 21, total: 154, trend: [1, 0, 1, 1, 0, 1, 1] },
    'snowflake':        { month: 9,  total: 71,  trend: [0, 0, 1, 0, 1, 0, 0] },
    'the-general':      { month: 27, total: 188, trend: [1, 1, 0, 1, 1, 1, 1] },
    'shea-homes':       { month: 7,  total: 63,  trend: [0, 0, 0, 1, 0, 0, 0] },
    'fca-canada':       { month: 14, total: 121, trend: [1, 0, 1, 0, 0, 1, 0] },
  };
  function clientBuildStats(slug) {
    if (window.MAV?.__live) return { month: null, total: null, trend: [], week: null, unavailable: true };
    const s = clientStats[slug] || { month: 0, total: 0, trend: [0, 0, 0, 0, 0, 0, 0] };
    return { ...s, week: s.trend.reduce((a, b) => a + b, 0) };
  }

  // Issue directory query — the seam the backend replaces with `GET /issues`.
  // Mirrors query params 1:1 so the API contract is fixed from the start:
  //   GET /issues?status&severity&state&type&assignee&reporter&client&label&q&sort&dir&page&pageSize
  // Returns { rows, total, page, pageSize, facets, query } so the directory
  // paginates and renders filter counts straight off the response shape.
  function queryIssues(params) {
    const currentIssues = window.MAV?.__live ? window.MAV.issues : issues;
    const p = Object.assign({ status: 'all', severity: 'all', state: 'all', type: 'all',
      assignee: 'all', reporter: 'all', client: 'all', label: 'all', q: '',
      sort: 'created', dir: 'desc', page: 1, pageSize: 25 }, params || {});
    const sevRank = { blocker: 0, high: 1, medium: 2, low: 3 };
    const norm = (s) => (s || '').toLowerCase();
    let rows = currentIssues.slice();
    if (p.status !== 'all') rows = rows.filter(i => i.status === p.status);
    if (p.severity !== 'all') rows = rows.filter(i => i.sev === p.severity);
    if (p.state !== 'all') rows = rows.filter(i => i.state === p.state);
    if (p.type !== 'all') rows = rows.filter(i => (i.type || 'Bug') === p.type);
    if (p.assignee !== 'all') rows = rows.filter(i => (i.assignee || 'unassigned') === p.assignee);
    if (p.reporter !== 'all') rows = rows.filter(i => (i.reporter || i.dev) === p.reporter);
    if (p.client !== 'all') rows = rows.filter(i => i.build === p.client);
    if (p.label !== 'all') rows = rows.filter(i => (i.labels || []).includes(p.label));
    if (p.q && p.q.trim()) {
      const s = norm(p.q);
      rows = rows.filter(i => norm([i.id, i.title, i.text, i.build, (i.labels || []).join(' ')].join(' ')).includes(s));
    }
    const cmp = {
      created: (a, b) => new Date(a.created) - new Date(b.created),
      updated: (a, b) => new Date(a.created) - new Date(b.created),
      due: (a, b) => new Date(a.due) - new Date(b.due),
      severity: (a, b) => sevRank[a.sev] - sevRank[b.sev],
      status: (a, b) => (a.status > b.status ? 1 : a.status < b.status ? -1 : 0),
      id: (a, b) => a.id.localeCompare(b.id, undefined, { numeric: true }),
      title: (a, b) => (a.title || '').localeCompare(b.title || ''),
    }[p.sort] || (() => 0);
    rows.sort(cmp);
    if (p.dir === 'desc') rows.reverse();
    const total = rows.length;
    const facets = {
      status: { open: currentIssues.filter(i => i.status === 'open').length, resolved: currentIssues.filter(i => i.status === 'resolved').length },
      severity: ['blocker', 'high', 'medium', 'low'].reduce((o, s) => (o[s] = currentIssues.filter(i => i.sev === s).length, o), {}),
      label: [...new Set(currentIssues.flatMap(i => i.labels || []))].sort(),
    };
    const start = (p.page - 1) * p.pageSize;
    return { rows: rows.slice(start, start + p.pageSize), total, page: p.page, pageSize: p.pageSize, facets, query: p };
  }

  function teamForMember(mid) { const m = (window.MAV?.__live ? window.MAV.team : team).find(x => x.id === mid); return m ? (window.MAV?.__live ? window.MAV.pods : pods).find(p => p.id === m.pod) : null; }
  function deptById(id) { return window.MAV?.__live ? null : org.departments.find(d => d.id === id); }
  function subDeptById(deptId, sid) { const d = deptById(deptId); return d && d.subDepts.find(s => s.id === sid); }
  // → { dept, subDept, team } names + a joined string "Email Production › Dedicated › Lunne"
  function teamPath(teamId) {
    const t = (window.MAV?.__live ? window.MAV.pods : pods).find(p => p.id === teamId); if (!t) return null;
    const d = deptById(t.dept), sd = subDeptById(t.dept, t.subDept);
    const parts = [d && d.name, sd && sd.name, t.name].filter(Boolean);
    return { dept: d && d.name, subDept: sd && sd.name, team: t.name, parts, str: parts.join(' › ') };
  }
  function memberPath(mid) { const t = teamForMember(mid); return t ? teamPath(t.id) : null; }

  // ── Codex usage (VD-01) — the sub-$0 engine's quota surfaces, replacing the $ meters.
  //   session = rolling 5h ChatGPT-sub window · weekly = honest 'pending' until PY-19.
  //   The 4 design states are driveable via MAV.setCodexState(name); the panels re-read
  //   on the 'goose-codex-usage' event. Countdowns are FE-derived from resetAt.
  // LIVE-WIRE (PY-21 · Vector): replace the presets with the real sidecar — fetch the
  //   codex quota (5h session % + resetAt; weekly when PY-19 lands), cache to _codexUsage,
  //   and dispatch 'goose-codex-usage'. Keep 'pending' honest until PY-19 (never a fake 0).
  const orgDefaultEngine = 'codex';
  const _mkReset = (min) => Date.now() + min * 60000;
  const CODEX_PRESETS = {
    live:    { sidecar: 'ok',          capMin: 2,  session: { usedPct: 63,  resetMin: 143 },            weekly: { state: 'live', usedPct: 41, resetMin: 5760 } },
    pending: { sidecar: 'ok',          capMin: 2,  session: { usedPct: 63,  resetMin: 143 },            weekly: { state: 'pending' } },
    nodata:  { sidecar: 'unreachable', capMin: 21, session: null,                                        weekly: { state: 'pending' } },
    limit:   { sidecar: 'ok',          capMin: 1,  session: { usedPct: 100, resetMin: 143, hit: true }, weekly: { state: 'pending' } },
  };
  let _codexUsage = null;
  function setCodexState(name) {
    const key = name in CODEX_PRESETS ? name : 'pending';
    const p = CODEX_PRESETS[key];
    _codexUsage = {
      state: key, sidecar: p.sidecar, capturedAt: Date.now() - p.capMin * 60000,
      session: p.session ? { ...p.session, resetAt: _mkReset(p.session.resetMin) } : null,
      weekly: p.weekly.state === 'live' ? { ...p.weekly, resetAt: _mkReset(p.weekly.resetMin) } : { ...p.weekly },
    };
    try { if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent('goose-codex-usage')); } catch (_) {}
    return _codexUsage;
  }
  // LIVE-WIRE (PY-21 · Vector): the REAL sidecar fetch — the live source that replaces the
  // demo presets. Maps GET /api/data/codex-rate-limit onto the _codexUsage shape the panels
  // read, caches _codexUsage, and dispatches 'goose-codex-usage'. Honest: a missing/unreadable
  // sidecar (the box's live state until a codex build emits a rate_limit_event) → 'nodata';
  // weekly stays 'pending' until PY-19 sources it (never a fake 0). Countdowns FE-derive from
  // resetAt. SEAM: PY-18's rate_limit_event carries status + resetsAt but NOT a 5h %; usedPct
  // flows through only when the endpoint provides one (else null for an allowed window — the
  // VD-01↔PY-18 percent-source seam, flagged to Viper/Havoc/darkstar). setCodexState() stays
  // for the mock/verify suite (Rooster's 4-state browser check).
  function refreshCodexUsage() {
    const api = typeof window !== 'undefined' && window.GooseAPI;
    if (!api || !api.codexRateLimit) return;
    const epoch = window.MAV?.__contextEpoch;
    const context = window.MAV?.__contextKey;
    api.codexRateLimit().then((d) => {
      if (window.MAV?.__contextEpoch !== epoch || window.MAV?.__contextKey !== context) return;
      if (!d || !d.available || !d.fiveHour) {
        _codexUsage = { state: 'nodata', sidecar: 'unreachable', capturedAt: Date.now(), session: null, weekly: { state: 'pending' } };
      } else {
        const f = d.fiveHour, hit = f.status === 'throttled';
        _codexUsage = {
          state: hit ? 'limit' : 'live', sidecar: 'ok',
          capturedAt: typeof d.capturedAt === 'number' ? d.capturedAt * 1000 : Date.now(),
          session: { usedPct: typeof f.usedPercent === 'number' ? f.usedPercent : (hit ? 100 : null), resetAt: Number(f.resetsAt) * 1000, hit },
          // Weekly (VD-01): codex emits it too — the token_count rate_limits.secondary window
          // (window_minutes 10080). Live when the sidecar carries it; honest 'pending' until then.
          weekly: (d.weekly && typeof d.weekly.usedPercent === 'number')
            ? { state: 'live', usedPct: d.weekly.usedPercent, resetAt: Number(d.weekly.resetsAt) * 1000 }
            : { state: 'pending' },
        };
      }
      try { if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent('goose-codex-usage')); } catch (_) {}
    }).catch(() => { /* keep last snapshot; never throw */ });
  }
  // Honest initial state = nodata (no sidecar) until the live fetch resolves; the mock/verify
  // suite overrides via setCodexState(name).
  _codexUsage = { state: 'nodata', sidecar: 'unreachable', capturedAt: Date.now(), session: null, weekly: { state: 'pending' } };
  refreshCodexUsage();

  return { clients, stageDefs, jobs, reviewFindings, presendActions, liveLog, pods, team, issues,
    slaHours, now, passRate, stageScores, org, currentUser,
    clientStats, clientBuildStats,
    orgDefaultEngine, getCodexUsage: () => _codexUsage, setCodexState, refreshCodexUsage,
    resetCodexUsage: () => { _codexUsage = { state: 'nodata', sidecar: 'unreachable', capturedAt: Date.now(), session: null, weekly: { state: 'pending' } }; },
    queryIssues,
    kbProfiles, kbRequests, kbMarkdown, kbRiskTags, submitKBEdit, decideKB,
    clientBySlug: (s) => clients.find(c => c.slug === s),
    memberById,
    me: () => memberById(currentUser),
    teamById: (id) => pods.find(p => p.id === id),
    teamForMember, teamPath, memberPath, deptById, subDeptById,
    issueById: (id) => issues.find(i => i.id === id),
    reportIssue, flagIssue, recordFeedback };
})();
